import type {AfriexAdminUser} from './AfriexAdmin';
import type {AfriexCountryCode} from './AfriexCountryCode';
import type {AfriexCurrencyCode} from './AfriexCurrencyCode';
import type {AfriexTransactionChannel} from './Transaction';

export {TierTypes, AfriexRateTierCode} from '@afriex/core/domain/enums';
import type {AfriexRateTierCode, TierTypes} from '@afriex/core/domain/enums';

export enum AfriexTierStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export interface AfriexTier {
  id?: string;
  name: string;
  discount: number;
  isActive?: boolean;
  shouldSkipFee?: boolean;
  transactionCountThreshold: number;
  transactionValueThreshold?: number;
  code?: AfriexRateTierCode;
  countries?: AfriexCountryCode[];
  type?: TierTypes;
  admin?: AfriexAdminUser;
  updatedAt?: string;
  createdAt?: string;
  userTotal?: number;
  transactionTotal?: number;
  currencies?: AfriexCurrencyCode[];
  sourceCurrencies?: AfriexCurrencyCode[];
  allowedSourceChannels?: AfriexTransactionChannel[];
  allowedDestChannels?: AfriexTransactionChannel[];
  allowedCountries?: AfriexCountryCode[];
}
